import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

export default class NoIndex extends PureComponent {
  static propTypes = { location: PropTypes.object.isRequired };
  render = () => {
    const { location } = this.props;
    if (!location.isTestLocation && !location.isTelemed) {
      return null;
    }

    return (
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
    );
  };
}
